import React from 'react';
import * as SS from '../CancellationBody.styles';
import * as S from './BreakUpInfo.styles';

const BreakUpInfo = ({header, updateActiveTab, breakupList, freeCancellationText, showPayModeButton=true}) => {
  const {cp_list, fb_list, ra_list} = breakupList;
    return(
      <SS.CancelBreakUpMainWrap>
        <SS.CancelBreakUpHeaderWrap>
          <SS.BreakupHeaderMainText>{header}</SS.BreakupHeaderMainText>
          <SS.BreakupHeaderSubText>{freeCancellationText}</SS.BreakupHeaderSubText>
        </SS.CancelBreakUpHeaderWrap>
        <S.CancelBreakOuterWrap>
          <S.BreakUpInfoWrap>
            {fb_list.map(item => <S.BreakupRow key={item.k}>
              <S.BreakUpInfoTextWrap>
                <S.BreakUpMainText fontSize={item.fs} fontWeight={item.fw} fontColor={item.cc}>{item.k}</S.BreakUpMainText>
              </S.BreakUpInfoTextWrap>
              <S.BreakUpPriceWrap>
                <S.BreakUpMainText fontSize={item.fs} fontWeight={item.fw} fontColor={item.cc}>{item.s}{item.c}{parseInt(item.v).toLocaleString('en-IN')}</S.BreakUpMainText>
              </S.BreakUpPriceWrap>
            </S.BreakupRow>)}
          </S.BreakUpInfoWrap>
          <S.BreakUpInfoWrap>
            {cp_list.map(item => <S.BreakupRow key={item.k}>
              <S.BreakUpInfoTextWrap>
                <S.BreakUpMainText fontSize={item.fs} fontWeight={item.fw} fontColor={item.cc}>{item.k}</S.BreakUpMainText>
              </S.BreakUpInfoTextWrap>
              <S.BreakUpPriceWrap>
                <S.BreakUpMainText fontSize={item.fs} fontWeight={item.fw} fontColor={item.cc}>{item.s}{item.c}{parseInt(item.v).toLocaleString('en-IN')}</S.BreakUpMainText>
              </S.BreakUpPriceWrap>
            </S.BreakupRow>)}
          </S.BreakUpInfoWrap>
          <S.BreakUpInfoWrap>
            {ra_list.map(item => <S.BreakupRow key={item.k}>
              <S.BreakUpInfoTextWrap>
                <S.BreakUpMainText fontSize={item.fs} fontWeight={item.fw} fontColor={item.cc}>{item.k}</S.BreakUpMainText>
              </S.BreakUpInfoTextWrap>
              <S.BreakUpPriceWrap>
                <S.BreakUpMainText fontSize={item.fs} fontWeight={item.fw} fontColor={item.cc}>{item.s}{item.c}{parseInt(item.v).toLocaleString('en-IN')}</S.BreakUpMainText>
              </S.BreakUpPriceWrap>
            </S.BreakupRow>)}
          </S.BreakUpInfoWrap>
        </S.CancelBreakOuterWrap>
        {(showPayModeButton && <SS.CancelBtnWrap>
          <SS.BackOptionWrap>
          </SS.BackOptionWrap>
          <SS.CancelButtonWrap onClick={() => updateActiveTab('confirm')}>
            <SS.CancelBtn>SELECT REFUND MODE</SS.CancelBtn>
            <SS.CancelInfoText>Refund will be sent to your chosen mode</SS.CancelInfoText>
          </SS.CancelButtonWrap>
        </SS.CancelBtnWrap>) || null}
      </SS.CancelBreakUpMainWrap>
    );
}

export default BreakUpInfo;